var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "x icon",
    transform: "translate(-911 -988)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    "data-name": "Ellipse 4884",
    transform: "translate(911 988)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M932.121 995.531h2.76l-6.03 6.892 7.094 9.378h-5.554l-4.35-5.688-4.978 5.688h-2.762l6.45-7.37-6.805-8.9h5.7l3.932 5.2Zm-.969 14.618h1.529l-9.871-13.053h-1.641Z",
    "data-name": "Path 47098"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.deef9855de7db7fde52d3502cf7ef4ba.svg";
export { ForwardRef as ReactComponent };